import React from 'react';
import { CircularProgress } from 'src/components/progress-bar';
import IconCSV from 'src/assets/images/icon-csv.png';

import './upload-loader.scss';

const UploadLoader = ({
    onCancel = () => {},
    percent = 100,
    filename = '',
}) => (
    <div className="UploadLoader">
        <div>
            <div className="progress">
                <CircularProgress
                    percent={percent}
                    style={{ width: '230px', height: '230px' }}
                />
                <img src={IconCSV} width="64" alt="Progresso do Upload" />
            </div>
            <div className="options">
                <div className="filename">
                    { filename }
                </div>
                <div>
                    <button type="button" onClick={onCancel}>Cancelar</button>
                </div>
            </div>
        </div>
    </div>
);

export default UploadLoader;
